import type { RouteRecordRaw } from 'vue-router'

export const subscriptionRoutes: RouteRecordRaw[] = [
  {
    path: '/pages/pricing',
    name: 'Subscription',
    component: () => import('./views/SubscriptionPage.vue'),
    meta: {
      title: 'subscription.My Subscription',
      requiresAuth: true,
      layout: 'full'
    }
  }
]

